import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // 'Access-Control-Allow-Credentials': 'true',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class SelfServiceService {
  private offlineUrl = this.conf.appConfig.apiBaseUrl;
  private url = this.conf.appConfig.apiBaseUrl;

  constructor(private client: HttpClient, private conf: AppConfigService) {}

  getAppointments() {
    const url = `${this.url}/api/online/appointment/getall?dorefresh=1`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getAppointmentsLocal() {
    const url = `${this.offlineUrl}/api/local/appointment/getall?dorefresh=1`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getConsultant(email) {
    const url = `${this.offlineUrl}/api/accounts/user/getall?email=${email}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postAppointment(
    Id: number,
    UserId: number,
    Name: string,
    UserEmail: string,
    Title: string,
    ScheduleDate: string,
    ScheduleTime: string,
    Comment: string,
    TotalAmount: number,
    IsPaid: boolean,
    RefNo: string,
    IsSynched: boolean,
    OnlineBranchId: number,
    AppointmentDetails: [
      {
        Id;
        AppointmentId;
        ItemOfServiceId;
        ItemOfServiceName;
        IsOPD;
        Amount;
        Dept;
        SubDept;
      }
    ],
    BranchName: string
  ) {
    const data = {
      Id,
      UserId,
      UserEmail,
      Title,
      ScheduleDate,
      ScheduleTime,
      Comment,
      TotalAmount,
      IsPaid,
      RefNo,
      IsSynched,
      OnlineBranchId,
      AppointmentDetails,
      BranchName,
      Name,
    };
    console.log(data);
    const url = `${this.url}/api/online/appointment/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getBranch() {
    const url = `${this.url}/api/online/branch`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatient(id) {
    const url = `${this.offlineUrl}/api/accounts/user/getall?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getBillItem() {
    const url = `${this.offlineUrl}/api/items/getall`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getItemOPD(id) {
    const url = `${this.offlineUrl}/api/items/getall?opd_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getResultFinalizer(
    startdate,
    enddate,
    dept_code,
    sub_dept_code,
    investigation,
    name,
    gender,
    phone,
    is_finalized
  ) {
    const url = `${this.url}/api/online/result/fetch?startdate=${startdate}&enddate=${enddate}&dept_code=${dept_code}&sub_dept_code=${sub_dept_code}&investigation=${investigation}&name=${name}&gender=${gender}&phone=${phone}&is_finalized=${is_finalized}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getResults() {
    const url = `${this.url}/api/online/result/fetch`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  saveResult(
    Id,
    OnlineBranchId,
    RefNo,
    OTP,
    PatientName,
    PatientAge,
    PatientGender,
    PatientOtherDetails,
    RegistrationCode,
    Email,
    Phone,
    StartDate,
    StopDate,
    IsVisibleToPatient,
    FinalizerEmail,
    FinalizerName,
    FinalizerComment,
    IsFinalized,
    DateFinalized,
    Title,
    ResultBody,
    LocalResultId,
    IsSynched
  ) {
    const data = {
      Id,
      OnlineBranchId,
      RefNo,
      OTP,
      PatientName,
      PatientAge,
      PatientGender,
      PatientOtherDetails,
      RegistrationCode,
      Email,
      Phone,
      StartDate,
      StopDate,
      IsVisibleToPatient,
      FinalizerEmail,
      FinalizerName,
      FinalizerComment,
      IsFinalized,
      DateFinalized,
      Title,
      ResultBody,
      LocalResultId,
      IsSynched,
    };
    console.log(data);
    const url = `${this.url}/api/online/result/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
}
